import {data} from './configurator-headlight-data.js';
import { vatRate, mainVat, subVat } from './tax-data.js';

document.addEventListener('DOMContentLoaded', function () {
  const brandSelect = document.getElementById('brand-select');
  const modelSelect = document.getElementById('model-select');
  const yearSelect = document.getElementById('year-select');
  const resultsDiv = document.getElementById('results');

  brandSelect.addEventListener('change', function () {
      const selectedBrand = this.value;
      modelSelect.innerHTML = '<option value="" disabled selected>Model</option>';
      yearSelect.innerHTML = '<option value="" disabled selected>Year</option>';
      resultsDiv.innerHTML = ''; // Clear results

      if (selectedBrand && data[selectedBrand]) {
          const models = Object.keys(data[selectedBrand]);
          models.forEach(function (model) {
              const option = document.createElement('option');
              option.value = model;
              option.textContent = model;
              modelSelect.appendChild(option);
          });
      }
  });

  modelSelect.addEventListener('change', function () {
      const selectedBrand = brandSelect.value;
      const selectedModel = this.value;
      yearSelect.innerHTML = '<option value="" disabled selected>Year</option>';
      resultsDiv.innerHTML = ''; // Clear results

      if (selectedBrand && selectedModel && data[selectedBrand][selectedModel]) {
          const years = Object.keys(data[selectedBrand][selectedModel]);
          years.forEach(function (year) {
              const option = document.createElement('option');
              option.value = year;
              option.textContent = year;
              yearSelect.appendChild(option);
          });
      }
  });


  yearSelect.addEventListener('change', function () {
      const selectedBrand = brandSelect.value;
      const selectedModel = modelSelect.value;
      const selectedYear = this.value;

      resultsDiv.innerHTML = ''; // Clear previous results

      if (selectedBrand && selectedModel && selectedYear && data[selectedBrand][selectedModel][selectedYear]) {
          const ledLights = data[selectedBrand][selectedModel][selectedYear];
          
          // Iterate over the LED lights and create HTML elements to display them
          for (const lightType of Object.keys(ledLights)) {
              let ledLight = formatForTheLink(lightType);
              const productLink = `/products/${lightType}`; // Just the URL

              Promise.all([
                fetchProductImage(productLink),
                fetchProductPrice(productLink)
              ])
              .then(([ imageUrl, price ]) => {
                displayProduct(productLink, imageUrl, ledLight, price)
              }).catch(error => {
                  console.error('Error fetching product data:', error);
                  // Handle error, e.g., show a placeholder image
              });
          }
      }
  });
})

function formatForTheLink(text) {
    return text
        .replace(/(cr-|crw-|dtsch2p-|-dfs1|-res|kl-|nd3-|crml-)|-/g, function(match, p1) {
            return p1 ? p1 : ' '; // Keeps the dashes for the ones shown above if not shown replaces them with a space
        })
        .split(' ')
        .map(word => {
            if (word.startsWith('cr-') || word.startsWith('crw-')|| word.startsWith('nd3-') || word.startsWith('st7') || word.startsWith('crw') || word.startsWith('dtsch2p-') || word.startsWith('-dfs1') || word.startsWith('-res') || word.startsWith('za') || word.startsWith('kl-') || word.startsWith('crml-')) {
                return word.toUpperCase(); // Makes it so the ones shown above get made to be capital letters
            }
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
}

function fetchProductImage(productUrl) {
    return fetch(productUrl)
        .then(response => response.text())
        .then(html => {
            // Create a new DOM parser to parse the HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Extract the URL of the main image (adjust selector as needed)
            const image = doc.querySelector('div.product__media img'); // Change to the correct selector
            return image ? image.src : ''; // Return the image URL or empty string if not found
        });
}

function fetchProductPrice(productUrl) {
  return fetch(productUrl)
        .then(response => response.text())
        .then(html => {
            // Create a new DOM parser to parse the HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Extract the URL of the main image (adjust selector as needed)
            const price = doc.querySelector('.price-item'); // Change to the correct selector
            return price ? price.innerHTML : 'No Price'; // Return the image URL or empty string if not found
        });
};

// This is makes the Ex or Inc vat show up next to the main price depending on which country you are in
function configTaxStatus () {
  const configVat = mainVat
  return configVat;
};

// This makes it so the ex/inc vat price shows up below the main price where applicable
function configTaxPrice(fetchProductPrice) {
  if (subVat != '') {
    let productPriceString = fetchProductPrice;
    let productCleanedPrice = productPriceString.replace("£","").replace(",",".").replace("GBP","");
    let dataPrice = Number(productCleanedPrice) * 100;
    let taxPrice = dataPrice * Number(vatRate);
    let moneyPrice = (taxPrice / 100).toFixed(2);
    let incVatPrice = `£${moneyPrice} ${subVat}`;
    return incVatPrice;
  } else {
    return ""
  }
}

function displayProduct(link, imageUrl, ledLight, price) {
  // Create a container div for the product
  const productContainer = document.createElement('div');
  productContainer.classList.add('product-container'); // Add a class for styling

  const imgContainer = document.createElement('div');
  imgContainer.classList.add('img-container');

  const infoContainer = document.createElement('div');
  infoContainer.classList.add('info-container');
  

  // Create an image element if imageUrl is available
  if (imageUrl) {
      const img = document.createElement('img');
      img.src = imageUrl;
      img.alt = 'Product Image';
      img.style.width = '200px'; // Adjust size as needed
      img.style.display = 'block'; // Ensure image displays on a new line
      imgContainer.appendChild(img); // Append the image to the product container
  }

  // Create a link element
  const productLink = document.createElement('a');
  productLink.href = link;
  productLink.textContent = ledLight; // Use the formatted display name
  productLink.target = '_blank'; // Open link in a new tab
  productLink.className = 'product-link'
  infoContainer.appendChild(productLink); // Append the link to the product container

  const productPrice = document.createElement('span')
  productPrice.textContent = price
  productPrice.className = 'product-price'
  infoContainer.appendChild(productPrice);

  const productVatStatus = document.createElement('span')
  productVatStatus.textContent = configTaxStatus();
  productVatStatus.className = 'vat-status';
  infoContainer.appendChild(productVatStatus);

  const productTaxPrice = document.createElement('p')
  productTaxPrice.textContent = configTaxPrice(price);
  productTaxPrice.className = 'tax-price';
  productTaxPrice.className = 'vat-status';
  infoContainer.appendChild(productTaxPrice);

  // Append the product container to the results div
  const resultsDiv = document.getElementById('results');
  resultsDiv.appendChild(productContainer);
  productContainer.appendChild(imgContainer);
  productContainer.appendChild(infoContainer);
}